module.exports = __webpack_public_path__ + "static/media/api.c9ac587c.svg";